module.exports = __webpack_public_path__ + "img/8b3ff21.jpg";